import Section from '../ui/Section'
import { Display, Statement, Body, Points, Accent } from '../ui/Type'

const OUTCOMES = [
  'Code shipped.',
  'Customers acquired.',
  'Deals advanced.',
  'Support issues resolved.',
  'Claims analyzed.',
  'Fraud detected.',
  'Research completed.',
  'Documents understood.',
  'Decisions made.',
  'Workflows automated.',
  'Agents completing work.',
]

const QUESTIONS = [
  'What needs to be accomplished?',
  'At what quality?',
  'At what scale?',
  'At what latency?',
  'With what privacy?',
  'Under what SLA?',
]

export default function TokenVsValue() {
  return (
    <Section id="workload" label="The unit of value" tone="tint">
      <Display>
        A token measures consumption.
        <br />
        The workload measures <Accent>value.</Accent>
      </Display>

      <Body className="mt-8">You don't deploy AI because you want tokens. You want:</Body>
      <Points className="mt-8" cols={2} items={OUTCOMES} />

      <Body className="mt-14">LiquidBrain starts with the workload.</Body>
      {/* The six questions are a checklist, not a sequence — no numbering, since
          nothing here happens in an order the reader needs to follow. */}
      <ul className="mt-8 grid grid-cols-1 gap-x-12 gap-y-6 sm:grid-cols-2">
        {QUESTIONS.map((q) => (
          <li key={q} className="border-t border-[var(--line)] pt-4 text-[1.05rem] leading-[1.45] text-[var(--ink)]">
            {q}
          </li>
        ))}
      </ul>
      <Body className="mt-8">Then LiquidBrain determines how the intelligence should execute.</Body>

      <Statement className="mt-[5.5rem]">
        The workload is the unit of value.
        <br />
        Not the token.
      </Statement>
    </Section>
  )
}
